import HTTP from "@/_helpers/http";
import { NOMINEE__API } from "@/_helpers/urls";
import toast from "@/services/Notification";
import { NOMINEE__ACTIONS } from "../action-types";
import { NOMINEE__MUTATIONS } from "../mutation-types";

const state = {
  nominees: [],
  selected: null,
};

const getters = {};

const mutations = {
  [NOMINEE__MUTATIONS.SET_NOMINEES](state, data) {
    state.nominees = data || [];
  },
  [NOMINEE__MUTATIONS.SET_SELECTED](state, data) {
    state.selected = data || null;
  },
};

const actions = {
  async [NOMINEE__ACTIONS.FETCH_NOMINEES]({ commit }) {
    try {
      const res = await HTTP({
        trackProgress: true,
        loadingText: "Processing...",
      }).get(NOMINEE__API.LIST);

      // res.data can be array OR lucids {data:[...]}
      const rows = Array.isArray(res.data) ? res.data : res.data?.data || [];
      commit(NOMINEE__MUTATIONS.SET_NOMINEES, rows);
    } catch (error) {
      console.log(error);
      toast.error("Failed to load nominees");
    }
  },

  async [NOMINEE__ACTIONS.SHOW_NOMINEE]({ commit }, id) {
    try {
      const res = await HTTP().get(NOMINEE__API.SHOW(id));
      commit(NOMINEE__MUTATIONS.SET_SELECTED, res.data);
      return res.data;
    } catch (error) {
      console.log(error);
      toast.error("Failed to load nominee details");
      return null;
    }
  },

  async [NOMINEE__ACTIONS.CREATE_NOMINEE]({ dispatch }, payload) {
    try {
      const res = await HTTP({
        trackProgress: true,
        loadingText: "Processing...",
      }).post(NOMINEE__API.CREATE, payload);

      toast.success(res.data?.message || "Nominee created successfully");
      await dispatch(NOMINEE__ACTIONS.FETCH_NOMINEES);
      return true;
    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message || "Failed to create nominee");
      return false;
    }
  },

  async [NOMINEE__ACTIONS.UPDATE_NOMINEE]({ dispatch }, { id, payload }) {
    try {
      const res = await HTTP({
        trackProgress: true,
        loadingText: "Processing...",
      }).put(NOMINEE__API.UPDATE(id), payload);

      toast.success(res.data?.message || "Nominee updated successfully");
      await dispatch(NOMINEE__ACTIONS.FETCH_NOMINEES);
      return true;
    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message || "Failed to update nominee");
      return false;
    }
  },
};

export default {
  namespaced: true,
  strict: process.env.NODE_ENV !== "production",
  state,
  getters,
  mutations,
  actions,
};
